import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../useAppDispatch';
import { getMenuItemIndex } from '../functions/getMenuItemIndex';
import { MenuItemsType } from '../types/menuTypes';
import useActiveMenuItems from './useActiveMenuItems';

interface UseMenuResult {
  handleClick: (value: string) => void;
  menuItems: MenuItemsType;
}

const useMenu = (): UseMenuResult => {
  const { menuItems } = useActiveMenuItems();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleGetMenuIndex = useCallback(
    (href: string) => {
      const menuIndex = getMenuItemIndex(menuItems, href);

      dispatch({
        type: 'SET_SELECTED_HIGHLIGHT',
        payload: { upper: menuIndex, lower: -1 },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menuItems, dispatch, location]
  );

  const handleClick = (href: string) => {
    handleGetMenuIndex(href);

    setTimeout(() => {
      navigate(href);
    }, 500);
  };

  useEffect(() => {
    handleGetMenuIndex(window.location.href);
  }, [handleGetMenuIndex]);

  useEffect(() => {
    dispatch({
      type: 'SET_SUB_ROUTE_PROGRESS',
      payload: 0,
    });
  }, [dispatch]);

  return { handleClick, menuItems };
};

export default useMenu;
